import { Component, OnInit, Inject } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'app-file-move-modal',
  templateUrl: './file-move-modal.component.html',
  styleUrls: ['../../rendered.component.scss', './file-move-modal.component.scss']
})
export class FileMoveModalComponent implements OnInit {
  data: any = {};

  constructor(public dialogRef: NbDialogRef<FileMoveModalComponent>) { }

  ngOnInit() {
    console.log(this.data)
  }

  moveTo(folder) {
    this.dialogRef.close(folder);
  }

}
